module.exports = __webpack_public_path__ + "static/img/til99.fcfff7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til99.png
// module id = qwxN
// module chunks = 1